/* Shared playback lifecycle for clear inline product/try-on players and native fallbacks. */
(() => {
  if (window.cpProductVideoLifecycle) return;
  window.cpProductVideoLifecycle = true;
  const selector = 'video[data-cp-product-video]';
  const observed = new WeakSet();
  const pause = video => { if (!video.paused) video.pause(); };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target;
      const inFullscreen = video.webkitDisplayingFullscreen || document.fullscreenElement === video || document.fullscreenElement?.contains(video);
      if (!entry.isIntersecting && !inFullscreen) pause(video);
    });
  }, { threshold: 0 }) : null;
  const mount = root => {
    const videos = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];
    videos.forEach(video => {
      if (observed.has(video)) return;
      observed.add(video);
      observer?.observe(video);
    });
  };
  document.addEventListener('play', event => {
    if (!event.target.matches?.(selector)) return;
    document.querySelectorAll('video[data-cp-product-video], media-gallery video, .cp-aura video').forEach(video => {
      if (video !== event.target) pause(video);
    });
  }, true);
  document.addEventListener('slideshow:select', event => {
    const slide = event.detail?.slide;
    if (!slide) return;
    event.target.querySelectorAll(selector).forEach(video => { if (!slide.contains(video)) pause(video); });
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll(selector).forEach(pause);
  });
  document.addEventListener('shopify:section:load', event => mount(event.target));
  const start = () => {
    mount(document);
    // The native variant picker can replace a media gallery without a section-load event.
    new MutationObserver(records => records.forEach(record => {
      record.addedNodes.forEach(node => { if (node.nodeType === 1) mount(node); });
      record.removedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        const videos = node.matches?.(selector) ? [node] : node.querySelectorAll(selector);
        videos.forEach(video => { if (!video.isConnected) { pause(video); observer?.unobserve(video); observed.delete(video); } });
      });
    })).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
